import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useState, useMemo } from "react";
import {
  getDeleteUser,
  getManageUserList,
} from "./manageuserVerification/utils";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "./../../../views/common/notification-message/notification";
import moment from "moment";
import DeleteUser from "./deleteUser";
import { Link } from "react-router-dom";
import Loading from "./../loader/loader";
import ManageUserContent from "./manageUserContent";
import NkHeader from "./../../common/nkheader";
import NkTable from "./../users/nktable";
import ReAssignRole from "./reAssignRole";
import RoleSelect from "./RoleSelect";
import { getManageuserdata } from "../settings/manageuserVerification/mockdata";
import { useHistory } from "react-router-dom";
import ChangePasswordConfirmation from "./changepasswordconfirmpopup";

const onChangeRole = (value) => {
  return console.log("value", value);
};

const manageuserheader = (
  {
    searchBy,
    setSearchByValue,
    modalShow,
    columnsExcel,
    setDeleteLoader,
    selectedRow,
    setSearchBy,
    fromDate,
    setFromDate,
    searchByValuePlaceholder,
    searchByValue,
    setDeleteUserShow,
    setReassignshow,
    handleFIlter,
    filterValues,
    manageUserList,
    setPagination,
    dataLoading,
    buttonRef,
    filterForm,
    onExcelClciked,
    manageUserListExcel,
    columns,
    columnsCsv,
    onDelete,
    pagination,
    setFilterForm,
    sizeShow,
    setSizeShow,
    deleteuserShow,
    reassignshow,
    handleChange,
    options,
    selectedOption,
    statusFilter,
    roleData,
    row,
    setModalShow,
    filtersSelected,
    noOfFiltersSelected,
    resetFilter,
    loader,
    roleinfo,
    handleRole,
    roleReassign,
    deleteLoader,
    handleSearch,
    rowEvents,

    role,
    setChangePasswordPopup,
    changePasswordPopup,
    handleChangeFilter,
    onPasswordChange,
    passwordResetLoader,
  },
  props
) => {
  const history = useHistory();
  // useEffect(() => {
  //   if (filterForm ) {
  //     setDeleteLoader(false);
  //     getManageUserTableList(filterForm);
  //   }
  // }, [filterForm]);

  // const getManageUserTableList = (request) => {
  //   request["userName"] = request.userName.length == 0 ? "" : request.userName;
  //   request["email"] = request.email.length == 0 ? "" : request.email;
  //   request["role"] = request.role.length == 0 ? "" : request.role;
  //   request.size = sizeShow || 10;
  //   setDeleteLoader(true);
  //   getManageUserList(request)

  //     .then((res) => {

  //       setDeleteLoader(false);
  //       if (
  //         res &&
  //         res.data &&
  //         res.data.userName
  //       ) {
  //         getManageUserTableList(res.data.userName || []);
  //         setPagination({
  //           ...pagination,
  //           pageSize: sizeShow || 10,
  //           total: res.data.totalCount,
  //           current: request.page,
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
  //       setDeleteLoader(false);
  //       getManageUserTableList([]);
  //     });
  // };

  // // delete api
  // const onDelete = () => {
  //   console.log('ROWW ::', selectedRow);
  //   setDeleteLoader(true);
  //  getDeleteUser (selectedRow)
  //     .then((res) => {
  //       setDeleteUserShow(false);
  //       setDeleteLoader(false);
  //       //message.success("Delete Successfully");
  //       openNotificationWithIcon(
  //         notificationStrings.success,
  //         "Delete Successfully"
  //       );

  //       getManageUserTableList(filterForm);
  //       // getReferrerCodeList(filterForm, username);
  //     })
  //     .catch((err) => {

  //       setDeleteUserShow(false);
  //       openNotificationWithIcon(notificationStrings.error, "ERROR");
  //       setDeleteLoader(false);
  //     });
  // };
  // console.log("manageUserListExcel", manageUserListExcel);
  // let formattedExceldata = useMemo(() => {
  //   let formattedExceldata = JSON.parse(JSON.stringify(manageUserList)).map(
  //     (element) => {
  //       if (element.createdDate) {
  //         element.createdDate = moment(element.createdDate).format(
  //           "DD-MM-YYYY"
  //         );
  //         if (element.role) {
  //           element.role = element.role.name;
  //         }
  //       }
  //       return element;
  //     }
  //   );
  //   return formattedExceldata;
  // }, [manageUserList]);

  return (
    <>
      <Container fluid>
        <NkHeader title="Manage User" />
        <ManageUserContent
          handleSearch={handleSearch}
          searchBy={searchBy}
          setSearchByValue={setSearchByValue}
          setSearchBy={setSearchBy}
          searchByValuePlaceholder={searchByValuePlaceholder}
          searchByValue={searchByValue}
          handleFIlter={handleFIlter}
          setModalShow={setModalShow}
          fromDate={fromDate}
          setFromDate={setFromDate}
          filtersSelected={filtersSelected}
          noOfFiltersSelected={noOfFiltersSelected}
          resetFilter={resetFilter}
          handleChangeFilter={handleChangeFilter}
        />

        <>
          <Row>
            <div
              className="col"
              style={{
                paddingRight: "1px",
                paddingLeft: "1px",
              }}
            >
              <Card style={{ padding: "1.25rem 1.5rem" }}>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      rowEvents={rowEvents}
                      rowHandler={false}
                      dataexcal
                      id="myTable"
                      filename={"manageuser"}
                      data={manageUserList}
                      buttonRef={buttonRef}
                      clientSide={false}
                      type="manageuser"
                      filterdata={filterForm}
                      onExcelClciked={() => onExcelClciked(filterForm)}
                      dataEXCEL={manageUserListExcel}
                      columns={columns}
                      columnsExcel={columnsExcel}
                      columnsCsv={columnsCsv}
                      pagination={pagination}
                      onPagechange={(page) => {
                        console.log("pagepage", page);
                        setFilterForm({
                          ...filterForm,
                          page: page,
                        });
                      }}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                        });
                      }}
                      onSizePerPageChange={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                        });
                      }}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      </Container>
      {
        <DeleteUser
          show={deleteuserShow}
          onHide={() => setDeleteUserShow(false)}
          onDelete={onDelete}
          deleteLoader={deleteLoader}
          statusFilter={statusFilter}
          selectedOption={selectedOption}
          options={options}
          handleChange={handleChange}
        />
      }
      {
        <ChangePasswordConfirmation
          show={changePasswordPopup}
          onHide={() => setChangePasswordPopup(false)}
          onPasswordChange={onPasswordChange}
          passwordResetLoader={passwordResetLoader}
          statusFilter={statusFilter}
          selectedOption={selectedOption}
          options={options}
          handleChange={handleChange}
        />
      }
      {/* <ReAssignRole
        show={reassignshow}
        onHide={() => setReassignshow(false)}
        onChangeRole={(e) => onChangeRole(e)}
        statusFilter={statusFilter}
        selectedOption={selectedOption}
        options={options}
        handleChange={handleChange}
        role={role}
      />  */}
      <RoleSelect
        show={modalShow}
        loader={loader}
        row={row}
        role={role}
        onHide={() => setModalShow(false)}
        handleRole={handleRole}
        roleinfo={roleinfo}
        roleReassign={roleReassign}
        roleData={roleData}
        selectedOption={selectedOption}
        options={options}
        handleChange={handleChange}
      />
    </>
  );
};

export default manageuserheader;
